/** Values of the `?ingest=` search param on the Transactions tab; absent = modal closed. */
export enum INGEST_PANEL {
	UPLOAD = 'upload',
	LIBRARY = 'library',
	PROCESSING = 'processing',
}

export const INGEST_SEARCH_PARAMS = {
	panel: 'ingest',
	batch: 'batch',
} as const;

export const MAX_UPLOAD_MB = 20;

export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

export const LIBRARY_PAGE_SIZE_OPTIONS = [10, 25, 50];

export const PROCESSING_POLL_INTERVAL_MS = 3000;

/** Pause after the last tick before opening the results. */
export const COMPLETE_REDIRECT_DELAY_MS = 600;
